import React from 'react';
import { useHistory } from 'react-router-dom';
import Button from '../../common/components/button';
import Div from '../../common/components/div';
import H1 from '../../common/components/h1';
import StackingButtons from '../../common/components/stacking.buttons';
import TranslatedSpan from '../../common/components/translated.span';

export default function DisplayAccountInfo(props) {
    const history = useHistory();
   
    const getGetPasswordButton = () => {
        return <>
            <Button
                color={'teal'}
                displayAs={'button'}
                fill={'outlined'}
                onClick={() => history.push('/forgot-password')}
                size={'small'}
            >
                <TranslatedSpan english={'Get password'}/>
            </Button>
        </>;
    };
   
    const getReturnToLoginButton = () => {
        return <>
            <Button
                color={'teal'}
                displayAs={'button'}
                fill={'solid'}
                onClick={() => history.push('/login')}
                size={'small'}
            >
                <TranslatedSpan english={'Return to Log in'}/>
            </Button>
        </>;
    };
   
    return (
        <Div isContainer={true}>
            <Div isRow={true}>
                <Div cols={12}>
                    <H1>
                        <TranslatedSpan english={'You currently have an account'}/>
                    </H1>
                </Div>
            </Div>
            <Div>
                <TranslatedSpan
                    className={'.ds-text'}
                    style={{
                        fontSize: 16,
                        fontWeight: 400
                    }}
                    english={'Your username is'}
                />
                <b> {props.userName}</b>.
            </Div>
            <Div style={{fontSize: 16, fontWeight: 380, paddingTop: 10}}>
                <TranslatedSpan
                    className={'.ds-text'}
                    style={{
                        fontSize: 16,
                        fontWeight: 400
                    }}
                    english={'Your account was created on'}
                />
                <span> {props.createdAt}</span>
            </Div>
            <StackingButtons
                button1={getReturnToLoginButton()}
                button2={getGetPasswordButton()}
            />
        </Div>
    );
}